export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/20 text-white text-sm font-medium mb-5">
              <i className="ri-mail-send-line"></i>
              <span>联系我们</span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-5">
              漫画推荐 · 意见反馈 · 合作联系
            </h2>
            <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
              有好看的漫画想推荐给我们？对平台有建议或想法？
              欢迎通过以下方式联系我们，YY漫画网期待你的声音。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-primary-600 font-semibold rounded-full hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-question-answer-line"></i>
                查看常见问题
              </a>
              <div className="flex items-center gap-3 text-white/80">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <span className="text-sm">contact@yymanhua.com</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8">
              <h3 className="text-white font-heading font-semibold text-lg mb-5">在线留言</h3>
              <form
                className="space-y-4"
                onSubmit={(e) => e.preventDefault()}
                data-readdy-form=""
              >
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <div className="flex flex-col sm:flex-row gap-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="你的昵称"
                    className="flex-1 px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/40 text-sm outline-none focus:border-white/40 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="电子邮箱"
                    className="flex-1 px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/40 text-sm outline-none focus:border-white/40 transition-colors"
                  />
                </div>
                <textarea
                  name="message"
                  placeholder="你的留言内容（如漫画推荐、意见建议等）"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/40 text-sm outline-none focus:border-white/40 transition-colors resize-none"
                />
                <button
                  type="submit"
                  className="w-full py-3 bg-white text-primary-600 font-semibold rounded-lg hover:bg-white/90 transition-colors cursor-pointer text-sm whitespace-nowrap"
                >
                  发送留言
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}